module.exports = {
    "vmContainer": "mc580d5799_vmContainer"
};